import { FaqPage } from '../../src/help-center/FaqPage';

export default FaqPage;
